import { Ai } from "@/patterns/ai-section/src";

export const AiSection = () => {
    const title = "Work smarter, not harder with AI";
    const buttonText = "Explore Atlassian Intelligence";
    const videoLink =
        "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/artificial-intelligence/ai-accelerate-work-jsw-generate-table.mp4";

    return (
        <Ai
            title={title}
            buttonText={buttonText}
            videoLink={videoLink}
            analyticsEventLabel="atlas-55799-ai-button-clicked"
        />
    );
};
AiSection.displayName = "AiSection";
